<div class="contModal" [ngClass]="{ backgroundheader: globalVars.FEATURES?.MSO_NewReBranding }">
  <button class="closeModal" (click)="closeLogin()">
    <ion-icon name="close-outline"></ion-icon>
  </button>
  <ng-container [ngTemplateOutlet]="activeStep === allSteps.Login ? login : password"></ng-container>
</div>
<ng-template #login>
  <form [formGroup]="loginForm" novalidate (submit)="doLogin()" (keydown.enter)="doLogin()">
    <ion-list>
      <ion-list-header class="hideTemp">
        <span
          ><ion-icon ios="ios-alert-outline" md="ios-alert-outline"></ion-icon>{{ "v2_login" | translate
          }}<!--# ¡Para poer apostar tienes que iniciar sesión!--></span
        >
      </ion-list-header>

      <ion-item class="cdr-item-input" lines="none">
        <ion-input
          class="ion-input-no-transform-label"
          labelPlacement="floating"
          label="{{ 'loginUserEmail' | translate }}"
          type="text"
          name="username"
          autocomplete="off"
          autoCorrect="off"
          spellcheck="off"
          #userInput
          formControlName="username"
        >
        </ion-input>
      </ion-item>

      <ion-item class="cdr-item-input" lines="none">
        <ion-input
          class="ion-input-no-transform-label"
          label="{{ 'loginPass' | translate }}"
          labelPlacement="floating"
          [type]="typePassword"
          name="password"
          autocomplete="off"
          autoCorrect="off"
          spellcheck="off"
          formControlName="password"
        ></ion-input>
        <ion-icon name="eye" *ngIf="!showPassword" (click)="onClickShowPassword()"></ion-icon>
        <ion-icon name="eye-off" *ngIf="showPassword" (click)="onClickShowPassword()"></ion-icon>
      </ion-item>
    </ion-list>
    <ion-button class="rePass" fill="clear" (click)="gotoStep(allSteps.GetPassword)">
      {{ "tForgotPass" | translate
      }}<!--¿Olvidaste tu contraseña?-->
    </ion-button>
    <div class="sendForm">
      <ion-button expand="full" type="submit" id="btnaccess">
        {{ "access" | translate
        }}<!--Acceder-->
      </ion-button>

      <ion-item class="keepSession" *ngIf="globalVars.isNative && !globalVars.FEATURES?.MSO_SkipAutologin">
        <ion-toggle labelPlacement="start" checked="false" name="rememberMe" formControlName="rememberMe">{{
          "stayConnec" | translate
        }}</ion-toggle>
      </ion-item>
    </div>
    <hr class="line" />
    <div class="goReg">
      <p>
        {{ "v2_registrado" | translate }}
        <!--# ¿Aún no estás registrado?-->
      </p>
      <ion-button expand="full" (click)="openRegistro()"
        >{{ "signUp" | translate
        }}<!--Regístrate--></ion-button
      >
    </div>
  </form>
</ng-template>
<ng-template #password>
  <form [formGroup]="resetForm" novalidate (submit)="doGetPassword()" (keydown.enter)="doGetPassword()">
    <ion-list>
      <div class="contactTitle">
        {{ "tRemPass" | translate }}
        <!--Recordar contraseña-->
      </div>

      <hr />
      <ion-item class="cdr-item-input passwordRecovery" lines="none">
        <ion-input
          class="ion-input-no-transform-label"
          label="{{ 'loginUserEmail' | translate }}"
          labelPlacement="floating"
          class="cdr-input-floating"
          type="text"
          name="user"
          formControlName="user"
        ></ion-input>
      </ion-item>

      <div class="myWrapInput" *ngIf="!globalVars?.FEATURES.MSO_LoginCaptchaDisabled">
        <div class="subTitleSub titleCaptcha">
          <span
            >{{ "cTQues" | translate
            }}<!--¿Cuánto es?--></span
          >
          <div class="captha">
            <img [src]="this.newLoginService.captchaUrl | async" alt="" class="captchaWrap" />
            <i class="icon-reload codere-icon icon-reload" (click)="newCaptcha()"></i>
          </div>
        </div>
        <ion-item class="cdr-item-input passwordRecovery" lines="none">
          <ion-input
            class="ion-input-no-transform-label"
            label="{{ 'v2_intrRes' | translate }}"
            labelPlacement="floating"
            class="cdr-input-floating"
            type="text"
            name="captcha"
            formControlName="captcha"
          ></ion-input>
        </ion-item>
      </div>
    </ion-list>

    <div>
      <ion-row>
        <ion-col col-6>
          <ion-button expand="full" fill="clear" (click)="gotoStep(allSteps.Login)">
            {{ "v2_volver" | translate
            }}<!--# Volver-->
          </ion-button>
        </ion-col>
        <ion-col col-6>
          <ion-button type="submit" expand="full">
            {{ "tHelpSend" | translate }}
            <!--Enviar-->
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </form>
</ng-template>
